import { createContext, useContext } from 'react'
import type { LoginResponse } from '@/api/auth'
import type { CurrentUser } from '@/types/user'

export const ME_QUERY_KEY = ['me'] as const

export interface AuthContextValue {
  user: CurrentUser | null
  /** True while the first /me request is in flight for a stored token. */
  initializing: boolean
  isAuthenticated: boolean
  login: (email: string, password: string, remember: boolean) => Promise<void>
  logout: () => Promise<void>
  applySession: (session: LoginResponse) => void
  refreshUser: () => Promise<CurrentUser | undefined>
}

export const AuthContext = createContext<AuthContextValue | null>(null)

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside <AuthProvider>')
  return ctx
}

/** Convenience for pages that are only rendered once the user is known. */
export function useCurrentUser(): CurrentUser {
  const { user } = useAuth()
  if (!user) throw new Error('useCurrentUser called outside an authenticated route')
  return user
}
